/* eslint-disable no-restricted-imports */
import { Box, Typography } from '@material-ui/core';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function EmptyState({ title, subtitle, icon }) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {icon && <Box className={classes.icon}>{icon}</Box>}
      <Typography variant='h6' color='textSecondary' className={classes.title}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant='body2' color='textSecondary' className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
};
